document.addEventListener("DOMContentLoaded", () => {
  const accordionItems = document.querySelectorAll(
    ".ombraz-v2pdp__accordion-item"
  );

  accordionItems.forEach((item, index) => {
    const header = item.querySelector(".ombraz-v2pdp__accordion-header");
    const content = item.querySelector(".ombraz-v2pdp__accordion-content");

    // Open the first item by default and set aria-expanded to true, but don't scroll
    /*  if (index === 0) {
      item.setAttribute("open", "");
      header.setAttribute("aria-expanded", "true");
    } */

    item.addEventListener("toggle", () => {
      if (item.open) {
        // Close other open items
        accordionItems.forEach((openItem) => {
          if (openItem !== item && openItem.hasAttribute("open")) {
            openItem.removeAttribute("open");
            openItem
              .querySelector(".ombraz-v2pdp__accordion-header")
              .setAttribute("aria-expanded", "false");
          }
        });

        header.setAttribute("aria-expanded", "true");

        // Scroll the opened item into view, but only if it's not the initial page load
        if (index !== 0 || document.readyState === "complete") {
          setTimeout(() => {
            const headerRect = header.getBoundingClientRect();
            const contentRect = content.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            if (headerRect.top < 0 || contentRect.bottom > windowHeight) {
              const scrollTarget = headerRect.top < 0 ? header : content;
              scrollTarget.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "nearest",
              });
            }
          }, 300); // Wait for the content to expand
        }
      } else {
        header.setAttribute("aria-expanded", "false");
      }
    });
  });
});
